var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiceBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 13,
    viewBox: "0 0 78 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12.0674,
    height: 12.0674,
    rx: 2,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 65 12.0674)",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0674,
    height: 12.0674,
    rx: 2,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 52 12.0674)",
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.0674,
    y: 12.0674,
    width: 12.0674,
    height: 12.0674,
    rx: 2,
    transform: "rotate(-180 38.0674 12.0674)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0674,
    height: 12.0674,
    rx: 2,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 39 12.0674)",
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0674,
    height: 12.0674,
    rx: 2,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 13 12.0674)",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 12.0674,
    height: 12.0674,
    rx: 2,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 0 12.0674)",
    fill: "black"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.0331 8.61977)",
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 58.034 6.03383)",
    fill: "white"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.0333,
    cy: 6.03383,
    rx: 1.14928,
    ry: 1.14928,
    transform: "rotate(-180 32.0333 6.03383)",
    fill: "white"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 71.0331 3.4474)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 67.5858 8.61977)",
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 55.16 8.61977)",
    fill: "white"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 42.4491 8.61977)",
    fill: "white"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 16.4471 6.03383)",
    fill: "white"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 67.5858 3.4474)",
    fill: "white"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 55.16 3.4474)",
    fill: "white"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.9074,
    cy: 3.4474,
    rx: 1.14928,
    ry: 1.14928,
    transform: "rotate(-180 34.9074 3.4474)",
    fill: "white"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 42.4491 3.4474)",
    fill: "white"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 74.4813 8.61977)",
    fill: "white"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 60.9061 8.61977)",
    fill: "white"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.1603,
    cy: 8.61977,
    rx: 1.14928,
    ry: 1.14928,
    transform: "rotate(-180 29.1603 8.61977)",
    fill: "white"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 47.62 8.61977)",
    fill: "white"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 21.62 6.03383)",
    fill: "white"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 6.03404 6.03383)",
    fill: "white"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 74.4813 3.4474)",
    fill: "white"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 60.9061 3.4474)",
    fill: "white"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.14928,
    ry: 1.14928,
    transform: "matrix(1 -8.74228e-08 -8.74228e-08 -1 47.62 3.4474)",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiceBlack);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };